import { GetEvaluationsResponseDTO } from '@/core/dto/psychosocial-report';
import type { GetEvaluationsResponse } from '@/types/Psychosocial';

export class GetEvaluationsMapper {
	constructor(private readonly data: GetEvaluationsResponseDTO) {}

	toDomain(): GetEvaluationsResponse {
		return this.data;
	}
}
